import {useSelector} from 'react-redux';
import {getIsShowMap} from '../helpers/fieldRules';

export function useIsShowMap(values) {
    const {limits} = useSelector(state => state.orderOptions.data);
    const {balance} = useSelector(state => state.balance);
    return getIsShowMap(values, limits, balance);
}
